module.exports = __webpack_public_path__ + "static/img/business7.d0976b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business7.jpg
// module id = s5rl
// module chunks = 9